(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name RegistreController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('RegistreController', RegistreController);

    RegistreController.$inject = ["$timeout","debugService","userService","$location"];

    function RegistreController($timeout,debugService,userService,$location)
    {
    	var vm = this;
    	vm.user = userService;
		vm.username = "";
		vm.password = "";
		vm.nom = "";
		vm.cognoms = "";
    	
    	vm.registre = function(form)
    	{
    		if(!form.$valid)
				return false;

			return vm.user.registre(vm.username,vm.password,vm.nom,vm.cognoms).then(function(data)
			{
                if(data.status == 200)
				    $location.url("/");
			});
    	};

    }

})();